<template lang="pug">
  ItemList(
    v-model="searchQuery"
    search-placeholder="Поиск по вариантам"
    :is-show-search-tip="variations.length === 0"
  )
    ItemListOption(
      v-for="variation in variations"
      input-name="variations"
      :id="variation.id"
      :key="variation.id"
      :desc="variation.desc"
      :price="getNormalPrice(variation.price)"
      :price-discount="getDiscountPrice(variation.price)"
      :checked="variation.id === currentVariationId"
      @change="changeHandler(variation.id)"
    )
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import priceToString from "@/mixins/price-to-string";
import ItemList from "@/components/ItemList/ItemList";
import ItemListOption from "@/components/ItemList/ItemListOption.vue";

export default {
  name: "VariationList",
  components: {
    ItemList,
    ItemListOption,
  },
  mixins: [priceToString],
  computed: {
    ...mapGetters('variation', {
      currentVariationId: 'getCurrentVariationId',
      getVariationsByDescIncludes: 'getVariationsByDescIncludes'
    }),
    variations() {
      return this.getVariationsByDescIncludes(this.searchQuery);
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  methods: {
    ...mapActions('variation', ['setCurrentVariation', 'clearVariationDependencies']),
    changeHandler(id) {
      this.setCurrentVariation(id);
      this.clearVariationDependencies();
      setTimeout(() => this.$router.go(-1), 150);
    },
    getNormalPrice(price) {
      return price?.norm
          ? this.priceToString(price?.norm)
          : ''
    },
    getDiscountPrice(price) {
      return price?.disc
          ? this.priceToString(price?.disc)
          : ''
    },
  },
};
</script>
